import { ResponseError } from 'sos-common/js/utils/ResponseError';
import {
  getErrorBodyVipSPSessionTimeout,
  getErrorBodyJwtTokenTimeout,
  dialogueErrorBody,
  getErrorBodyApiErrorOnSaveClose,
} from 'sos-eservice-common/js/config';

/**
 * Returns a context aware [[dialogueErrorBody]]
 * @param response
 * @param myPageLink
 * @param errorBodyOnApiError Optional parameter to override the default error body on API operations error
 */
export function getDialogueByResponse(
  response: ResponseError,
  myPageLink: string,

  errorBodyOnApiError?: dialogueErrorBody,
  translations?: (key: string, defaultValue?: string) => string
): dialogueErrorBody {
  let errorBody: dialogueErrorBody;

  //timeout sp or jwt
  if (response.body.detailCode) {
    switch (response.body.detailCode) {
      case '401.1':
        errorBody = getErrorBodyVipSPSessionTimeout(response.body.redirectUri, translations);
      case '401.2':
        errorBody = getErrorBodyJwtTokenTimeout(response.body.redirectUri);
    }
  } else {
    //api error
    errorBody =
      errorBodyOnApiError || getErrorBodyApiErrorOnSaveClose(myPageLink, response.body.errorMessage, translations);
  }
  return errorBody;
}
